import PropTypes from 'prop-types';
import * as React from 'react';

function SvgSettings24(_ref) {
  let {
    color,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    color: color,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2a2 2 0 012 2v1.674l.295.149c.103.055.204.112.304.172l.287.182 1.346-.775a2 2 0 012.649.6l.083.132 1 1.732a2 2 0 01-.732 2.732l-1.265.731.024.318L19 12c0 .223-.01.444-.031.664l-.027.225 1.29.745a2 2 0 01.805 2.594l-.073.138-1 1.732a2 2 0 01-2.732.732l-1.535-.886-.222.134c-.09.052-.182.102-.275.15l-.2.096V20a2 2 0 01-1.85 1.995L13 22h-2a2 2 0 01-2-2l-.001-1.676-.199-.097a6.986 6.986 0 01-.275-.15l-.223-.133-1.534.886a2 2 0 01-2.649-.6l-.083-.132-1-1.732a2 2 0 01.732-2.732l1.289-.745-.026-.225a7.05 7.05 0 01-.023-.331L5 12a7.1 7.1 0 01.009-.354l.023-.318-1.264-.73a2 2 0 01-.805-2.594l.073-.138 1-1.732a2 2 0 012.732-.732l1.344.776.288-.183c.1-.06.202-.117.305-.172l.294-.149L9 4a2 2 0 011.85-1.995L11 2zm0 2h-2v3.049l-.667.235a4.991 4.991 0 00-1.515.86l-.536.442-2.514-1.452-1 1.732 2.475 1.429L7.1 11a5.028 5.028 0 00.038 2.172l.174.726-2.544 1.468 1 1.732 2.66-1.536.53.407c.417.32.88.572 1.375.747l.667.235V20h2v-3.049l.667-.235a4.987 4.987 0 001.374-.747l.53-.407 2.661 1.536 1-1.732-2.544-1.468.174-.726A5.016 5.016 0 0016.9 11l-.142-.705 2.474-1.43-1-1.732-2.515 1.45-.535-.441a4.991 4.991 0 00-1.515-.859L13 7.05zm-1 5a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z",
    fill: "currentColor"
  }));
}

SvgSettings24.propTypes = {
  color: PropTypes.string,
  dataTest: PropTypes.string
};
export default SvgSettings24;